// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__TTXgB","buttons":"PendingPaymentAlert_buttons__2qBOX"};